var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spiral"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 17C17.2652 17 17.5196 17.1054 17.7071 17.2929C17.8946 17.4804 18 17.7348 18 18C18 18.5304 17.7893 19.0391 17.4142 19.4142C17.0391 19.7893 16.5304 20 16 20C15.6056 20.0017 15.2147 19.9252 14.85 19.775C14.4853 19.6248 14.1539 19.4039 13.875 19.125C13.5961 18.8461 13.3752 18.5147 13.225 18.15C13.0748 17.7853 12.9983 17.3944 13 17C13 15.9391 13.4214 14.9217 14.1716 14.1716C14.9217 13.4214 15.9391 13 17 13C18.3261 13 19.5979 13.5268 20.5355 14.4645C21.4732 15.4021 22 16.6739 22 18C22 19.5913 21.3679 21.1174 20.2426 22.2426C19.1174 23.3679 17.5913 24 16 24C14.1435 24 12.363 23.2625 11.0503 21.9497C9.7375 20.637 9 18.8565 9 17C9.00331 14.8793 9.84722 12.8464 11.3468 11.3468C12.8464 9.84722 14.8793 9.00331 17 9C19.3869 9 21.6761 9.94821 23.364 11.636C25.0518 13.3239 26 15.6131 26 18C26 19.3132 25.7413 20.6136 25.2388 21.8268C24.7362 23.0401 23.9997 24.1425 23.0711 25.0711C22.1425 25.9997 21.0401 26.7362 19.8268 27.2388C18.6136 27.7413 17.3132 28 16 28C13.0826 28 10.2847 26.8411 8.22183 24.7782C6.15893 22.7153 5 19.9174 5 17C5 13.8174 6.26428 10.7652 8.51472 8.51472C10.7652 6.26428 13.8174 5 17 5C18.7072 5 20.3977 5.33625 21.9749 5.98957C23.5521 6.64288 24.9852 7.60045 26.1924 8.80761C27.3996 10.0148 28.3571 11.4479 29.0104 13.0251C29.6637 14.6023 30 16.2928 30 18",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalories);
export default __webpack_public_path__ + "static/media/Calories.b174885fd0f0d06287220bf6b8b1332b.svg";
export { ForwardRef as ReactComponent };